import React, { useEffect, useRef } from 'react';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import { parsePhoneNumberFromString } from 'libphonenumber-js';

const PhoneInputComponent = ({ t, phone, setPhone, phoneError, setPhoneError }) => {
  const hasNormalizedRef = useRef(false);

  // Common logic to parse phone number with fallback countries
  const parsePhoneNumber = (value) => {
    if (!value) return null;

    // Try parsing with + prefix first (for numbers with country codes)
    let phoneNumber = parsePhoneNumberFromString(`+${value}`);

    // If invalid, try parsing with default countries (for legacy numbers without country codes)
    if (!phoneNumber || !phoneNumber.isValid()) {
      phoneNumber = parsePhoneNumberFromString(value, 'US')
                    || parsePhoneNumberFromString(value, 'CA')
                    || parsePhoneNumberFromString(value, 'GB');
    }

    return phoneNumber;
  };

  // Normalize phone number format when data is loaded from backend
  useEffect(() => {
    if (phone && !hasNormalizedRef.current) {
      hasNormalizedRef.current = true;

      const phoneNumber = parsePhoneNumber(phone);

      // If we found a valid phone number, ensure it's in the format PhoneInput expects
      if (phoneNumber && phoneNumber.isValid()) {
        const formattedForInput = phoneNumber.countryCallingCode + phoneNumber.nationalNumber;

        // Only update if format is different
        if (phone !== formattedForInput) {
          setPhone(formattedForInput);
        }
        setPhoneError('');
      }
      else {
        setPhone(phoneNumber.countryCallingCode + phone);
      }
    }
  }, [phone]);

  const handlePhoneChange = (value, country, e, formattedValue) => {
    hasNormalizedRef.current = true;
    setPhone(value);
  };

  return (
    <div className="input__block">
      <label>
        {t("Primary Phone")} <span className="mandatory">*</span>
      </label>

      <PhoneInput
        
        value={phone}
        onChange={handlePhoneChange}
        inputProps={{
          name: 'phoneNumber',
          required: true,
          autoFocus: false,
        }}
        inputClass={phoneError ? 'border__red' : ''}
      />

      {phoneError && (
        <span className="error-color-red">{phoneError}</span>
      )}
    </div>
  );
};

export default PhoneInputComponent; 


